// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import storeState from '@/store'
import VueResource from 'vue-resource'
import '../static/css/mui.min.css'
import 'iview/dist/styles/iview.css'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'element-ui/lib/theme-chalk/table.css'
import 'element-ui/lib/theme-chalk/table-column.css'
import '@/assets/less/base.less'
import '@/assets/less/transition.less'
import '@/assets/less/mixin.less'
import '../static/css/reset.css'
import '@/assets/fonts/iconfont.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueLazyload from 'vue-lazyload'


Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueAwesomeSwiper)
Vue.use(MintUI)
Vue.use(VueLazyload,{
	error: '',
  loading: ''
})



  localStorage.setItem("baseUrl", "https://www.dgmpt.com:8077/");

// localStorage.setItem("baseUrl", "http://localhost:6800/");




localStorage.setItem("imgsURL", "");


/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	storeState,
	template: '<App/>',
	components: {
		App
	}
})



// WEBPACK FOOTER //
// ./src/main.js